export default {
    text: "<p>对您的订单有疑问？<br/>请参阅我们的<a href='#' role='button' data-widget-trigger='{widgetOptions}'><b>支持中心</b></a>寻求帮助</p><p>您需要未列出的产品吗？<br/>单击<a href='#' role='button' data-widget-trigger='{widgetOptions}'><b>此处</b></a>发送建议</p>"
}